import React, { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const QUESTIONS = [
  { label: "P — Problem", q: "Qual è la principale difficoltà nella comunicazione?", field: "problem", scoreField: "need_score", max: 25 },
  { label: "G — Goal", q: "Cosa vorreste ottenere?", field: "goal", scoreField: "fit_score", max: 20 },
  { label: "B — Budget", q: "Quanto può investire?", field: "budget", scoreField: "budget_score", max: 20 },
  { label: "T — Timing", q: "Quando vuole partire?", field: "timing", scoreField: "timing_score", max: 20 },
  { label: "D — Decision maker", q: "Chi decide?", field: "decision_maker", scoreField: "authority_score", max: 15 },
];

export const fitScore = (qual) => QUESTIONS.reduce((s, q) => s + Number(qual[q.scoreField] || 0), 0);

export const QualifyTab = ({ p, onSave }) => {
  const [qual, setQual] = useState(p.qualification || {});
  useEffect(() => { setQual(p.qualification || {}); }, [p.qualification]);

  const set = (k, v) => setQual((q) => ({ ...q, [k]: v }));
  const total = fitScore(qual);

  return (
    <>
      <p className="text-xs text-muted-foreground">Le 5 domande di qualificazione (P·G·B·T·D) → Client Fit Score</p>
      {QUESTIONS.map((q) => (
        <div key={q.field} className="rounded-xl border border-border p-3">
          <div className="mb-1 flex items-center justify-between">
            <Label className="text-sm font-semibold">{q.label}</Label>
            <div className="flex items-center gap-1">
              <Input type="number" min={0} max={q.max} value={qual[q.scoreField] ?? ""} onChange={(e) => set(q.scoreField, e.target.value)} className="h-7 w-16 text-center text-xs" />
              <span className="text-xs text-muted-foreground">/{q.max}</span>
            </div>
          </div>
          <p className="mb-2 text-xs text-muted-foreground">{q.q}</p>
          <Textarea value={qual[q.field] || ""} onChange={(e) => set(q.field, e.target.value)} rows={2} />
        </div>
      ))}
      <div className="flex items-center justify-between rounded-xl border border-border bg-secondary/40 p-4">
        <span className="label-caps text-muted-foreground">Client Fit Score</span>
        <span className="font-heading text-2xl font-bold text-primary tabular-nums">{total}<span className="text-sm text-muted-foreground">/100</span></span>
      </div>
      <Button onClick={() => onSave({ ...qual, client_fit_score: total })} className="w-full" data-testid="save-qual-btn">Salva qualificazione</Button>
    </>
  );
};
